import { Pipe, PipeTransform } from "@angular/core";
import { CategoriesData } from "../../providers/categories";

@Pipe({
  name: "category"
})
export class CategoryPipe implements PipeTransform {

  constructor(
    private categoriesData: CategoriesData
  ) { }

  transform(idCategory: string, clientId: string) {
    return this.categoriesData.getClientCategoriesById(clientId, idCategory);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/category/category.ts